export var BlockLogLevel;
(function (BlockLogLevel) {
    BlockLogLevel["Debug"] = "Debug";
    BlockLogLevel["Info"] = "Info";
    BlockLogLevel["Warn"] = "Warn";
    BlockLogLevel["Error"] = "Error";
})(BlockLogLevel || (BlockLogLevel = {}));
/** Reads a stored or user-supplied level, falling back when it is not one we recognise. */
export function toBlockLogLevel(level, fallbackLevel = BlockLogLevel.Info) {
    return Object.values(BlockLogLevel).includes(level)
        ? level
        : fallbackLevel;
}
//# sourceMappingURL=blockLog.js.map